import { API_HOST } from "@/utils/apiBase";
import DEFAULT_AVATAR from "@/assets/no-avatar-icon-preevnt.png";

// profileImageURL reaches storage in three different shapes, so normalise here
// instead of at each call site:
//
//   POST /login        → "/storage/{profile_photo}" — a RELATIVE path, and
//                        literally "/storage/null" when the user has no photo,
//                        because the caller interpolates a null column into a
//                        template string.
//   POST /upload-photo → Storage::url(...), an ABSOLUTE url built from the
//                        backend's APP_URL — or JSON null, which becomes the
//                        string "null" once Storage.setItem coerces it.
//
// Prefixing API_HOST onto the absolute form gives "http://apihttp://app/…",
// and onto "null" gives "http://api/null". Both render as a broken image.
const ABSENT = ["null", "undefined", "/storage/null", "/storage/undefined"];

export function avatarUrl(storedPath) {
  const path = storedPath == null ? "" : String(storedPath).trim();
  if (!path || ABSENT.indexOf(path) !== -1) return DEFAULT_AVATAR;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_HOST}${path}`;
}

export { DEFAULT_AVATAR };
